import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const requireAuth = () => (to, from, next) => {
  if (store.state.token !== null) {
    return next();
  }
  else{
    next('/login');
  }
};

const router = new VueRouter({
    mode: 'history',
    routes: [
          {
            path: '/login',
            name: 'login',
            component: () => import('../components/Common/Login')
          },
          {
            path: '/',
            name: 'Home',
            component: () => import('../components/Dashboard'),
            beforeEnter: requireAuth()
          },
          {
            path: '/sensor',
            name: 'sensor',
            component: () => import('../components/Monitor/Sensor'),
            beforeEnter: requireAuth()
          },
          {
            path: '/chartjs',
            name: 'VueChartJS',
            component: () => import('../components/Chart/VueChartJS'),
            beforeEnter: requireAuth()
          },
          {
            path: '/chartkick',
            name: 'VueChartKick',
            component: () => import('../components/Chart/VueChartKick'),
            beforeEnter: requireAuth()
          },
          {
            path: '/charts',
            name: 'VueCharts',
            component: () => import('../components/Chart/VueCharts'),
            beforeEnter: requireAuth()
          },
          {
            path: '/OrganizationMaster',
            name: 'OrganizationMaster',
            component: () => import('../components/Master/OrganizationMaster'),
            beforeEnter: requireAuth()
          },
          {
            path: '/ProductionMaster',
            name: 'ProductionMaster',
            component: () => import('../components/Master/ProductionMaster'),
            beforeEnter: requireAuth()
          },
          {
            path: '/EquipmentMaster',
            name: 'EquipmentMaster',
            component: () => import('../components/Master/EquipmentMaster'),
            beforeEnter: requireAuth()
          },
          {
            path: '/PartMaster',
            name: 'PartMaster',
            component: () => import('../components/Master/PartMaster'),
            beforeEnter: requireAuth()
          }, {
            path: '/CooperatorMaster',
            name: 'CooperatorMaster',
            component: () => import('../components/Master/CooperatorMaster'),
            beforeEnter: requireAuth()
          },
          {
            path: '/CustomerMaster',
            name: 'CustomerMaster',
            component: () => import('../components/Master/CustomerMaster'),
            beforeEnter: requireAuth()
          },
          {
            path: '/SPCMaster',
            name: 'SPCMaster',
            component: () => import('../components/Master/SPCMaster'),
            beforeEnter: requireAuth()
          },
          {
            path: '/XMRSearch',
            name: 'XMRSearch',
            component: () => import('../components/SPC/XMRSearch'),
            beforeEnter: requireAuth()
          },
          {
            path: '/AnomalyList',
            name: 'AnomalyList',
            component: () => import('../components/SPC/Anomaly/AnomalyList'),
            beforeEnter: requireAuth()
          },
          {
            path: '/ThermoHygromerterMenu',
            name: 'ThermoHygromerterMenu',
            component: () => import('../components/SPC/Thermo-hygromerter/ThermoHygromerterMenu'),
            beforeEnter: requireAuth()
          },
          {
            path: '/Report8D',
            name: 'Report8D',
            component: () => import('../components/Common/Report8D'),
            beforeEnter: requireAuth()
          },
          {
            path: '/IncomingInspection',
            name: 'IncomingInspection',
            component: () => import('../components/QPC/incoming/IncomingInspection'),
            beforeEnter: requireAuth()
          },
          {
            path: '/InprocessInspection',
            name: 'InprocessInspection',
            component: () => import('../components/QPC/inprocess/InprocessInspection'),
            beforeEnter: requireAuth()
          },
          {
            path: '/OutgoingInspection',
            name: 'OutgoingInspection',
            component: () => import('../components/QPC/outgoing/OutgoingInspection'),
            beforeEnter: requireAuth()
          },
          {
            path: '/ProcessCapability',
            name: 'ProcessCapability',
            component: () => import('../components/QPC/process/ProcessCapability'),
            beforeEnter: requireAuth()
          },
          {
            path: '/KPIIndicator',
            name: 'KPIIndicator',
            component: () => import('../components/QPC/KPI/KPIIndicator'),
            beforeEnter: requireAuth()
          }
    ]
})

export default router

